/**
 * 订单页签数量纯函数：列表接口返回后，用同一筛选条件下的 res.data_total
 * 修正当前页签的括号数量，其他页签保持全量统计不变。
 * 无副作用：不修改传入对象，始终返回新对象。
 */
function applyFilteredTabCount(tabCounts, status, filteredTotal) {
  const result = { ...tabCounts }
  if (status === 'PAID_OFF') {
    result.wait_ship_num = filteredTotal
  } else if (status === 'CONFIRM') {
    result.confirm_num = filteredTotal
  }
  return result
}

module.exports = { applyFilteredTabCount }
